<template>
  <div class="modal" v-if="step1||step2||step3">
    <div
      :style="{
      position:'absolute',
      top:domSetting.offsetTop+'px',
      left:domSetting.offsetLeft+'px',
    }">
      <div v-if="step1">
        <el-popover :value="true" trigger="manual" placement="bottom">
          <div slot="reference" style="z-index: 9999;background-color:#FFFFFF;padding: 10px 16px;">
            <i style="color: #FFA500FF" class="el-icon-s-opportunity"></i>
            <span style="color: #00AEFF;padding: 10px">如何获取API KEY及采集说明</span>
          </div>
          <div>
            <p>查看API KEY配置操作说明及采集教程</p>
            <el-button @click="clickStep(1)" type="text">下一步(1/3)</el-button>
          </div>
        </el-popover>
      </div>
      <div v-if="step2">
        <el-popover :value="true" trigger="manual" placement="bottom">
          <div slot="reference"
               style="min-height: 30px;padding: 10px 16px;z-index: 9999;background-color: #FFFFFF;position: relative">
            <i style="color: #FFA500FF" class="el-icon-s-opportunity"></i>
            <span class="recharge_btn">购买</span>
          </div>
          <div>
            <p>如需充值点击购买，进入购买页面</p>
            <el-button @click="clickStep(2)" type="text">下一步(2/3)</el-button>
          </div>
        </el-popover>
      </div>
      <div v-if="step3">
        <el-popover :value="true" trigger="manual" placement="bottom">
          <div slot="reference" class="authentication_box"
               style="min-height: 30px;padding: 10px 16px;z-index: 9999;background-color: #FFFFFF;position: relative">
            <i style="color: #FFA500FF" class="el-icon-s-opportunity"></i>
            <span>
              <svg t="1644993215860" class="icon" viewBox="0 0 1024 1024" version="1.1"
                   xmlns="http://www.w3.org/2000/svg"
                   p-id="7593" width="200" height="200">
                <path
                  d="M960 896H64c-35.2 0-64-28.8-64-64V192c0-35.2 28.8-64 64-64h896c35.2 0 64 28.8 64 64v640c0 35.2-28.8 64-64 64z m32-704c0-19.2-12.8-32-32-32H64c-19.2 0-32 12.8-32 32v640c0 19.2 12.8 32 32 32h896c19.2 0 32-12.8 32-32V192z m-416 224h320v32H576v-32z m0-96h320v32H576v-32z m41.6 307.2l80 41.6 153.6-118.4c9.6-9.6 25.6-9.6 35.2 0 9.6 9.6 9.6 25.6 0 35.2l-172.8 172.8c-3.2 6.4-9.6 9.6-16 9.6s-12.8-3.2-19.2-6.4l-99.2-99.2c-9.6-9.6-9.6-25.6 0-35.2 12.8-12.8 28.8-12.8 38.4 0zM512 720c0 6.4 0 9.6-3.2 16h-32c0-6.4 3.2-9.6 3.2-16 0-80-70.4-144-160-144s-160 64-160 144c0 6.4 0 9.6 3.2 16h-32c-3.2-6.4-3.2-9.6-3.2-16 0-76.8 51.2-137.6 124.8-163.2-35.2-22.4-60.8-64-60.8-108.8 0-70.4 57.6-128 128-128s128 57.6 128 128c0 44.8-25.6 86.4-60.8 108.8 73.6 25.6 124.8 86.4 124.8 163.2zM416 448c0-54.4-41.6-96-96-96s-96 41.6-96 96 41.6 96 96 96 96-41.6 96-96z"
                  fill="#666666" p-id="7594"></path>
              </svg>
            </span>
          </div>
          <div>
            <p>进行实名认证可获赠 <span style="font-size: 14px;color: #FF4D4D">30金币</span></p>
            <el-button @click="clickStep(3)" type="text">完成</el-button>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      domSetting: {},
      step1: false,
      step2: false,
      step3: false,
    }
  },
  mounted() {
    localStorage.getItem('firstLogin') === null ? localStorage.setItem('firstLogin', '1') : null;
    if (localStorage.getItem('firstLogin') && localStorage.getItem('firstLogin') === '1') {
      this.getPosition(document.querySelector('.get_help1'));
      this.step1 = true;
    }
  },
  methods: {
    getPosition(el) {
      //获取元素距离顶部的位置
      let offsetTop = el.getBoundingClientRect().top - 5;
      //获取元素距离左边的位置
      let offsetLeft = el.getBoundingClientRect().left - 5;
      this.domSetting = {offsetTop, offsetLeft};
    },
    clickStep(val) {
      if (val === 1) {
        this.step1 = false;
        this.getPosition(document.querySelector('.recharge'));
        this.step2 = true;
      }
      if (val === 2) {
        this.step2 = false;
        this.getPosition(document.querySelector('.authentication_ioc'));
        this.step3 = true;
      }
      if (val === 3) {
        this.step3 = false;
        localStorage.setItem('firstLogin', '0')
      }
    }
  },
}
</script>

<style scoped>
body {
  overflow-y: hidden;
  overflow-x: hidden;
  position: relative;
}

.modal {
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  user-select: none;
}

.recharge_btn {
  color: #FEAC3E;
  width: 60px;
  text-align: center;
  padding: 5px 15px;
  margin: 0 0 0 10px;
  border-radius: 2px;
  border: 1px solid #FEAC3E;
  font-size: 14px;
}

.authentication_box {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.authentication_box svg {
  width: 16px;
  height: 16px;
  margin: 0 4px;
}
</style>

<style>
.modal .el-popover {
  width: 100%;
  top: 44px;
  font-size: 13px;
}

.modal .el-popover:before {
  position: absolute;
  top: -8px;
  content: "";
  width: 0;
  height: 0;
  border-bottom: 8px solid #ededed;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
}


</style>



// WEBPACK FOOTER //
// src/components/guide.vue